<template>
  <div>
    <a-box>
      <o-form
        :title="$t('cpv.addAllowedHash')"
        :initial-values="initialValues"
        :inputs="inputs"
        :submit-text="$t('common.save')"
        @submit="addAllowedHash"
      />
    </a-box>
  </div>
</template>

<script>
  import { ABox, OForm } from 'codefabrik-gui-vue'
  import { ComponentSelect } from '@/components'
  import { useAddAllowedHash } from '@/views/cpv/cpvHooks'

  export default {
    name: 'AllowedHashAdd',
    components: { ABox, OForm},
    computed: {
      initialValues () {
        return {
          component: this.$route.query.component || 'bridge',
          hash: null
        }
      },
      inputs () {
        return [
          {
            name: 'component',
            is: ComponentSelect,
            properties: {
              label: this.$t('cpv.component')
            },
            validators: 'required'
          },
          {
            name: 'hash',
            properties: {
              label: this.$t('cpv.hash')
            },
            validators: 'required'
          }
        ]
      }
    },
    mixins: [useAddAllowedHash()]
  }
</script>

<style scoped>

</style>
